import { defineStore } from 'pinia'

export const CurrentData = defineStore('r_d_data', {
    state: () => {
        return { r_d_data: null }
    },
    actions: {
        get() {
            return this.r_d_data
        },
        set(value) {
            this.r_d_data = value
        }
    },
})

export const CurrentDialog = defineStore('r_d_dialog', {
    state: () => {
        return { r_d_dialog: false }
    },
    actions: {
        get() {
            return this.r_d_dialog
        },
        set(value) {
            this.r_d_dialog = value
        }
    },
})